import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-about-description">
          
            <h1 style={{ fontSize: "2.6em" }}>
              About Me
            </h1>
            <p className="home-about-body" style={{ textAlign: "center" }}>
            I've had an interest in tech since I was twelve, and today I get to do it every day as a
              <i>
                <b className="purple"> Software Engineer at Spacely Media</b>
              </i>
              , building full-stack features for a two-sided media marketplace.
              <br />
              <br />I work mostly in
              <i>
                <b className="purple"> Python, JavaScript, React, FastAPI, PostgreSQL, and Redis, </b>
              </i>
              and I'm also comfortable with C++, Java, and R.
              <br />
              <br />
              Some of my CS interests consist of &nbsp;
              <i>
                <b className="purple">System Architecture, Machine Learning, and Deep Learning </b>
              </i>
              <br />
              <br />
              In my free time, I like to keep up to date with what is new in the tech world and build side projects. I self-host this website on a home server I built, and I also like to play sports.
            </p>
          </Col>
         
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Jayson-Gonzalez"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/jayson-gonzalez-70381b260/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/jayson_gonzalez_"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
